import React, { useState } from 'react';
import './NewBanner.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewBanner() {
    const [mensaje, setMensaje] = useState('');
    const [imagenPreview, setImagenPreview] = useState(null);
    const [isImageSelected, setIsImageSelected] = useState(false);
    const [isImagenVideo, setIsImagenVideo] = useState(false);
    const [smallImagenPreview, setSmallImagenPreview] = useState(null);
    const [isSmallImageSelected, setSmallIsImageSelected] = useState(false);
    const [isSmallImagenVideo, setIsSmallImagenVideo] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [esFinanciacion, setEsFinanciacion] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleSamllImagenChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const esVideo = file.type.startsWith('video/');
        setIsSmallImagenVideo(esVideo);

        if (esVideo) {
            // Los videos no pasan por la validación de altura (pensada para imágenes)
            const previewURL = URL.createObjectURL(file);
            setSmallImagenPreview(previewURL);
            setSmallIsImageSelected(true);
            return;
        }

        const img = new Image();
        img.src = URL.createObjectURL(file);
        console.log("img.height", img.height);

        img.onload = () => {
            console.log("img.onload", img.width );

            if (img.height > 500) {
                toast.error("Image height must not exceed 500px.");
                event.target.value = ""; // reset the file input
                setSmallImagenPreview(null);
                setSmallIsImageSelected(false);
                return;
            }

            if (file) {
                const previewURL = img.src;
                setSmallImagenPreview(previewURL);
                setSmallIsImageSelected(true);
            }
        };
    };
    const handleImagenChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);
            setIsImagenVideo(file.type.startsWith('video/'));
        }
    };

    const handleFinanciacionChange = (event) => {
        setEsFinanciacion(event.target.checked);
    };

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        
        // Agregar el campo de financiación al FormData
        formData.append('financiacion', esFinanciacion);
        
        const resetForm = () => {
            form.reset();
            setImagenPreview(null);
            setIsImageSelected(false);
            setIsImagenVideo(false);
            setSmallImagenPreview(null);
            setSmallIsImageSelected(false);
            setIsSmallImagenVideo(false);
            setEsFinanciacion(false);
        };
        setMensaje('');

        if (!formData.get('imagen')) {
            toast.error('Por favor, seleccione una imagen.');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/bannersPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span>   Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Banner</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">
                            <div className="flexGrap">
                                <fieldset>
                                    <legend>
                                        Imagen
                                    </legend>
                                    <label htmlFor="imagen"> </label>
                                    <input
                                        type="file"
                                        id="imagen"
                                        name="imagen"
                                        accept="image/*,video/mp4,video/quicktime"
                                        onChange={handleImagenChange}
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>
                                        Texto del banner (opcional)
                                    </legend>
                                    <input
                                        type="text"
                                        id="texto"
                                        name="texto"
                                        placeholder="Ej: 100% Financiada"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>
                                        Es un Banner de Financiación?
                                    </legend>
                                    <div className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            id="financiacion"
                                            name="financiacion"
                                            checked={esFinanciacion}
                                            onChange={handleFinanciacionChange}
                                        />
                                        <label htmlFor="financiacion">
                                            Check para confirmar
                                        </label>
                                    </div>
                                </fieldset>
                                <fieldset>
                                    <legend>
                                        Imagen móvil
                                    </legend>
                                    <label htmlFor="smallImagen"> </label>
                                    <input
                                        type="file"
                                        id="smallImagen"
                                        name="smallImagen"
                                        accept="image/*,video/mp4,video/quicktime"
                                        onChange={handleSamllImagenChange}
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>
                                        Texto del banner móvil (opcional)
                                    </legend>
                                    <input
                                        type="text"
                                        id="smallTexto"
                                        name="smallTexto"
                                        placeholder="Ej: 100% Financiada"
                                    />
                                </fieldset>
                            </div>
                            {isImageSelected &&
                                <div className='previevCategori'>
                                    {isImagenVideo ? (
                                        <video src={imagenPreview} muted controls />
                                    ) : (
                                        <img src={imagenPreview} alt="Vista previa" />
                                    )}
                                </div>
                            }
                            {isSmallImageSelected &&
                                <div className='previevCategori' style={{display: 'flex', alignItems: 'baseline', gap: '10px'}}>
                                    {isSmallImagenVideo ? (
                                        <video src={smallImagenPreview} muted controls />
                                    ) : (
                                        <img src={smallImagenPreview} alt="Vista previa" />
                                    )}
                                    <span>Imagen móvil</span>
                                </div>
                            }
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}